<template>
    <div class="circle-cloud">
        <v-progress-circular
                :width="0.13"
                :value="progressValue"
                color="rgba(0,46,167,0.5)"
                style="width:100%;height:100%;"
        >
            <div ref="circleOne" class="circle-one">
                <div tag="div" >
                    <div class="field" ref="iconsone" v-for="(icon,index) in icons.one" :key="'one_'+icon.src">
                        <img v-if="index==0" ref="imagesInCircleOne" :src="iconPath+houseIconSource"
                             :style="iconDefaultStyle+'opacity:'+iconOpacity(houseIconSource)+';left:'+Math.round(containerWidth/2 + circleOne.radius * Math.cos(angleDefault+circleOne.offset+(index*circleOneStep)) - iconWidth/2)+'px;top:'+Math.round(containerHeight/2 + circleOne.radius * Math.sin(angleDefault+circleOne.offset+(index*circleOneStep)) - iconHeight/2)+'px'">
                        <img v-if="index==1" ref="imagesInCircleOne" :src="iconPath+incomeIconSource"
                             :style="iconDefaultStyle+'opacity:'+iconOpacity(incomeIconSource)+';left:'+Math.round(containerWidth/2 + circleOne.radius * Math.cos(angleDefault+circleOne.offset+(index*circleOneStep)) - iconWidth/2)+'px;top:'+Math.round(containerHeight/2 + circleOne.radius * Math.sin(angleDefault+circleOne.offset+(index*circleOneStep)) - iconHeight/2)+'px'">
                        <img v-if="index==10" ref="imagesInCircleOne" :src="iconPath+employmentIconSource"
                             :style="iconDefaultStyle+'opacity:'+iconOpacity(employmentIconSource)+';left:'+Math.round(containerWidth/2 + circleOne.radius * Math.cos(angleDefault+circleOne.offset+(index*circleOneStep)) - iconWidth/2)+'px;top:'+Math.round(containerHeight/2 + circleOne.radius * Math.sin(angleDefault+circleOne.offset+(index*circleOneStep)) - iconHeight/2)+'px'">
                        <img v-else ref="imagesInCircleOne" :src="iconPath+icon.src"
                             :style="iconDefaultStyle+'opacity:'+iconOpacity(icon.src)+';left:'+Math.round(containerWidth/2 + circleOne.radius * Math.cos(angleDefault+circleOne.offset+(index*circleOneStep)) - iconWidth/2)+'px;top:'+Math.round(containerHeight/2 + circleOne.radius * Math.sin(angleDefault+circleOne.offset+(index*circleOneStep)) - iconHeight/2)+'px'">
                    </div>
                </div>
            </div>
            <div ref="circleTwo" class="circle-two">
                <div tag="div" >
                    <div class="field" ref="iconstwo" v-for="(icon,index) in icons.two" :key="'two_'+icon.src">
                        <img  ref="imagesInCircleTwo" :src="iconPath+icon.src"
                             :style="iconDefaultStyle+'opacity:'+iconOpacity(icon.src)+';left:'+Math.round(containerWidth/2 + circleTwo.radius * Math.cos(angleDefault+circleTwo.offset+(index*circleTwoStep)) - iconWidth/2)+'px;top:'+Math.round(containerHeight/2 + circleTwo.radius * Math.sin(angleDefault+circleTwo.offset+(index*circleTwoStep)) - iconHeight/2)+'px'">
                    </div>
                </div>
            </div>
            <div ref="circleThree" class="circle-three">
                <div tag="div" >
                    <div class="field" ref="iconsthree" v-for="(icon,index) in icons.three" :key="'three_'+icon.src">
                        <img  ref="imagesInCircleThree" :src="iconPath+icon.src"
                             :style="iconDefaultStyle+'opacity:'+iconOpacity(icon.src)+';left:'+Math.round(containerWidth/2 + circleThree.radius * Math.cos(angleDefault+circleThree.offset+(index*circleThreeStep)) - iconWidth/2)+'px;top:'+Math.round(containerHeight/2 + circleThree.radius * Math.sin(angleDefault+circleThree.offset+(index*circleThreeStep)) - iconHeight/2)+'px'">
                    </div>
                </div>
            </div>
            <div ref="hotspotIcon" class="hotspot-icon">
                <div class="field" ref="centralicon">
                    <img :src="'/icons/qa/'+hotspotIconSource"
                         :style="hotspotIconStyle+'opacity:'+hotspotIconOpacity+';left:'+Math.round(containerWidth/2 - hotspotDiameter/2)+'px;top:'+Math.round(containerHeight/2 - hotspotDiameter/2)+'px'"
                         >
                </div>
            </div>
        </v-progress-circular>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";

    export default {
        name: "IconWorld",
        data(){
            return {
                index: 0,
                containerWidth: 0,
                containerHeight: 0,
                innerWidth: 0,
                iconPath: '/icons/cloud/',
                iconWidth: 40,
                iconHeight: 40,
                hotspotDiameter: 80,
                iconDefaultStyle: 'width: 40px; height: 40px; position: absolute; background: transparent;opacity:1;',
                iconOneOneStyle: 'width: 40px; height: 40px; position: absolute; background: transparent;',
                hotspotIconStyle: 'width: 80px; height: 80px; position: absolute; background: transparent;',
                angleDefault: 0,
                circleOne:{
                    radius: 85,
                    offset: 135
                },
                circleTwo:{
                    radius: 140,
                    offset: 135
                },
                circleThree:{
                    radius: 200,
                    offset: 135
                },
                icons: {
                    hotspot: {
                        src: 'HotspotSingleOne.svg'
                    },
                    one: [
                        {
                            src: '1_0'
                        },
                        {
                            src: '1_1'
                        },
                        {
                            src: 'Motorrad-Auto.svg',
                        },
                        {
                            src: 'Transportation Scooters Bikes scooter-1.svg',
                        },
                        {
                            src: 'Pets-Animals Dogs dog-poodle.svg',
                        },
                        {
                            src: 'Building-Construction Conception Projects project-blueprint-buildings.svg',
                        },
                        {
                            src: 'Real-Estate - Actions-Buildings - real-estate-action-building-dollar.svg',
                        },
                        {
                            src: 'Real-Estate - Favorites - real-estate-favorite-hold-house.svg',
                        },
                        {
                            src: 'Real-Estate Insurance Protection real-estate-insurance-dollar-hand.svg',
                        },
                        {
                            src: 'Building-Construction Construction construction-house-1.svg',
                        },
                        {
                            src: '1_10',
                        }
                    ],
                    two: [
                        {
                            src: 'Ecology Nuclear-Fossil-Energy fossil-energy-gas-latern.svg',
                        },
                        {
                            src: 'Ecology Nuclear-Fossil-Energy fossil-energy-barrel.svg',
                        },
                        {
                            src: 'Ecology Renewable-Energy renewable-energy-solar-panel.svg',
                        },
                        {
                            src: 'Ecology Renewable-Energy renewable-energy-solar-power.svg',
                        },
                        {
                            src: 'Ecology - Renewable-Energy - renewable-energy-water-dam-1.svg',
                        },
                        {
                            src: 'Entertainment-Event-Hobbies Museum-Exhibitions museum-painting.svg',
                        },
                        {
                            src: 'Transportation - Sea Transportation - sea-transport-wheel-boat.svg',
                        },
                        {
                            src: 'FahrradPedelec.svg'
                        },
                        {
                            src: 'Transportation Segway segway-2.svg',
                        },
                        {
                            src: 'Entertainment-Event-Hobbies - Party - party-music.svg',
                        },
                        {
                            src: 'Family-Babies-Kids Family family-children.svg'
                        },
                        {
                            src: 'Pets-Animals - Animals-Prints - animal-print.svg',
                        },
                        {
                            src: 'Science Astronomy astronomy-telescope.svg',
                        },
                        {
                            src: 'Transportation Cars car-voyage.svg',
                        },
                        {
                            src: 'Money-Payments-Finance - Crypto-Currencies - crypto-currency-bitcoin-stack-coins.svg',
                        },
                        {
                            src: 'Avatars Natural-Men-Vintage vintage-man-1.svg',
                        },
                        {
                            src: 'Science Space-Exploration space-astronaut.svg'
                        },
                    ],
                    three:[
                        {
                            src: 'Health-Beauty - Insurance-Protection - insurance-card.svg',
                        },
                        {
                            src: 'Money-Payments-Finance Finance Savings saving-bank.svg',
                        },
                        {
                            src: 'Technology Drones drone-camera.svg',
                        },
                        {
                            src: 'Transportation Scooters Bikes scooter-3.svg',
                        },
                        {
                            src: 'Social-Medias-Rewards-Rating - Love-It - love-it-ribbon-2.svg',
                        },
                        {
                            src: 'Sports Tennis-Badminton tennis-forehand.svg',
                        },
                        {
                            src: 'Sports Biking biking-person.svg',
                        },
                        {
                            src: 'Sports Fitness fitness-weightlift.svg',
                        },
                        {
                            src: 'Sports Martial-Arts martial-arts-karate.svg',
                        },
                        {
                            src: 'Sports Skiing ski-jumping.svg',
                        },
                        {
                            src: 'Outdoors-Recreation Diving diving-diver.svg',
                        },
                        {
                            src: 'Sports Biking biking-mountain.svg',
                        },
                        {
                            src: 'Outdoors-Recreation Nautical-Sports nautic-sports-sailing-person.svg',
                        },
                        {
                            src: 'Outdoors-Recreation Outdoor-Parks outdoors-horse.svg',
                        },
                        {
                            src: 'Sports Dancing dancing-ballet.svg',
                        },
                        {
                            src: 'Health-Beauty Dentistry dentistry-tooth-exchange.svg',
                        },
                        {
                            src: 'Health-Beauty Dentistry dentistry-tooth-search.svg',
                        },
                        {
                            src: 'Clothes-Footwear-Accessories - Glasses - glasses-sun-1.svg',
                        },
                        {
                            src: 'Health-Beauty Hospital hospital-building-1.svg',
                        },
                        {
                            src: 'Health-Beauty Medical-Symbol medical-hospital-2.svg',
                        },
                        {
                            src: 'Health-Beauty Hospital-Bedrooms hospital-bedroom-nurse.svg'
                        },
                        {
                            src: 'saving-money-flower.svg',
                        },
                        {
                            src: 'Building-Construction Houses house-modern_wannahave.svg',
                        },
                        {
                            src: '3',
                        },
                        {
                            src: '4'
                        },
                        {
                            src: '5',
                        },
                        {
                            src: '6',
                        }
                    ]
                }
            }
        },
        props: ['progressValue','topLevelIndex'],
        computed: {
            circleOneStep(){
                return (2*Math.PI / 11);
            },
            circleTwoStep(){
                return (2*Math.PI / 17);
            },
            circleThreeStep(){
                return (2*Math.PI / 27);
            },
            hotspotIconOpacity(){
                /*
                if(parseInt(this.topLevelIndex)>3) {
                    return '1';
                }
                 */
                return '1';
            },
            ...mapGetters("qa", {
                hotspotIconSource: "getHotspotIconSource",
                houseIconSource: "getHouseIconSource",
                employmentIconSource: "getEmploymentIconSource",
                incomeIconSource: "getIncomeIconSource",
                questionHasAnswer: 'getQuestionHasAnswer'
            })
        },
        methods: {
            getMyClass(index){
                return this.icons.three[index].status;
            },
            changeStatus(index){
                // schlichter Test
                if(this.icons.three[index].status == 'active'){ this.icons.three[index].status = ''; }
                else { this.icons.three[index].status = 'active'; }

            },
            iconOpacity(icon){
                if(icon === undefined || icon === '') {
                    return '0';
                }
                if(this.$store.getters['qa/getIconIsInAnswers'](icon)) {
                    return '1';
                }
                return '0';
            },
        },
        mounted(){
            this.containerWidth = this.$refs.circleOne.offsetWidth;
            this.containerHeight = this.$refs.circleOne.offsetHeight;
            this.innerWidth = window.innerWidth;
            // add needed responsivity to the progress component
            // ( the outer circle was outside of the cloud on mobile devices)
            var element = document.querySelector('div.v-progress-circular svg');
            var trans = ("rotate(-90deg) scale(1.7)");
            if(this.innerWidth > 599) {
                trans = ("rotate(-90deg) scale(1.25)");
            }
            element.style.transform=(trans);
            element.style.webkitTransform = (trans);
            element.style.MozTransform = (trans);
            element.style.msTransform = (trans);
        }
    }



</script>

<style scoped>
    .circle-cloud {
        height: 390px;
        margin-bottom: 0em;
        margin-left: auto;
        margin-right: auto;
        position: relative;
    }
    /* .circle-cloud { transform: scale(0.5);} */
    .circle-one, .circle-two, .circle-three { width: 1px; height: 1px; position: absolute; left: 50%; top: 50%; }
    .circle-one { z-index: 10; }
    .circle-two { z-index: 11; }
    .circle-three { z-index: 12; }
    .circle-one img { opacity: 0; }
    .circle-two img { opacity: 0; }
    .circle-three img { opacity: 0; }
    .hotspot-icon { position: absolute; left: 50%; top: 50%; }
    #center { width: 10px; height: 10px; position: absolute; left: 295px; top: 295px; background: #000; }
    .field { width: 30px; height: 30px; position: absolute; background: transparent; }
    #crosshair-x { width: 600px; height: 1px; background: #000; position: absolute; left: 0; top: 300px; }
    #crosshair-y { width: 1px; height: 600px; background: #000; position: absolute; left: 300px; top: 0; }
    .test { display: block;}
    div.v-progress-circular svg {
        /*
        transform: scale(1.7);

         */
    }

    img {
        transition: left 1s ease-in-out;
        transition: top 1s ease-in-out;
        transform: scale(1);
    }
    img.active {
        transform: scale(1.2) !important;
    }

</style>
